// @noflow
import {
    getDayScheduleEvents,
    getSelectedDay,
    getSelectedEvent,
    isShowingPopup
} from '~/core/state/ui/schedule/selectors';

import { connect } from 'react-redux';
import Event from './component';
import { updateEventStart } from '~/core/state/ui/schedule/actions';

const mapStateToProps = (state, ownProps) => {
    const { componentId } = ownProps;
    const showingPopup = isShowingPopup(state, { componentId });
    const selectedDay = getSelectedDay(state, ownProps);
    const selectedEvent = getSelectedEvent(state, ownProps);
    const numEventsInSelectedDay =
        selectedDay !== null
            ? getDayScheduleEvents(state, {
                  componentId,
                  dayIndex: selectedDay
              }).size
            : null;

    return {
        ...ownProps,
        numEventsInSelectedDay,
        selectedDay,
        selectedEvent,
        showingPopup
    };
};

const mapDispatchToProps = (dispatch, { componentId }) => ({
    updateEventStart: (dayIndex, eventIndex, newStartTime) =>
        dispatch(
            updateEventStart({
                componentId,
                dayIndex,
                eventIndex,
                newStartTime
            })
        )
});

export default connect(mapStateToProps, mapDispatchToProps)(Event);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/svg-container/index.js